import VueComponent from "vue";
export const rules = {
  required: (value: string | number | boolean) => {
    return value === false || value === 0 || !!value || "Required.";
  },
  mustBeTrue: (value: string | number | boolean) => {
    return value === true || "Required.";
  },
  emailFormat: (v: string) => /.+@.+\..+/.test(v) || "E-mail must be valid",
  yearFormat: (v: string) =>
    /^\d{4}$/.test(v.trim()) || "Please enter a 4-digit year",
  filesize: (file: File) => {
    return !file || file.size < 15728640 || "File size must be less than 15 mb";
  },
  beforePandemic: (v: string) =>
    Number(v) < 2021 ||
    "Sorry, your business does not qualify for this grant. Only businesses established prior to the pandemic qualify.",
};

export function scrollToFirstInvalidElement(
  component: VueComponent,
  formRef: VueComponent
) {
  // @ts-ignore
  const firstInvalidInput = formRef.inputs.find(
    // @ts-ignore
    (input) => !input.valid
  );

  component.$smoothScroll({
    scrollTo: firstInvalidInput.$el,
  });
}
